import React from 'react';
import { IconRefresh } from '../Icons';

/**
 * Inner shell that every dashboard widget renders inside the SortableWidget wrapper.
 * The wrapper is responsible for the editing chrome (drag handle, hide button, resize
 * handles), so this shell only concerns itself with title, subtitle, loading, and
 * error states.
 */
function WidgetShell({
  title,
  subtitle,
  loading,
  error,
  onRetry,
  children,
  bodyClassName = '',
  widgetClassName = '',
}) {
  return (
    <div className={['dashboard-widget', widgetClassName].filter(Boolean).join(' ')}>
      <div className="dashboard-widget-header">
        <div className="dashboard-widget-titles">
          <span className="dashboard-widget-title">{title}</span>
          {subtitle ? <span className="dashboard-widget-subtitle">{subtitle}</span> : null}
        </div>
      </div>
      <div className={`dashboard-widget-body ${bodyClassName}`}>
        {loading ? (
          <div className="dashboard-widget-state dashboard-widget-loading" role="status" aria-live="polite">
            <span className="dashboard-widget-spinner" aria-hidden="true">
              <IconRefresh size={20} />
            </span>
            <span>Loading…</span>
          </div>
        ) : error ? (
          <div className="dashboard-widget-state dashboard-widget-error" role="alert">
            <p className="dashboard-widget-error-text">{error}</p>
            {onRetry ? (
              <button type="button" className="dashboard-widget-retry" onClick={onRetry}>
                Retry
              </button>
            ) : null}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}

export default WidgetShell;
